import axios from 'axios'
import api from './api'
import { Message } from 'element-ui'

//创建axios实例对象
let instance = axios.create({
    // baseURL: 'http://localhost:8080/api', // 测试服务器地址
    baseURL: '/api', // 线上使用相对路径，交给Nginx反向代理转发
    timeout: 1000 * 60 * 2 //默认超时时长
})

//请求拦截器
instance.interceptors.request.use(config=>{
    //此处编写请求拦截的代码，一般用于弹出加载窗口
    config.headers.token = localStorage.getItem('weizhanToken')
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理
    if (err.response.status == 401) {
        Message({
            type: 'error',
            message: '用户登录已失效，请重新登录'
        })
        window.location.href = '/#/login'
    }
    // return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            // api[option.url],
            option.url,
            {params: option.params}
        ).then(res=>{
            result = res.data
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
            // api[option.url],
            option.url,
            option.params
        ).then(res=>{
            result = res.data
        }).catch(err=>{
            result = err
        })
    }

    return result
}

export default http
